import React, { ReactNode } from 'react';
import './JobListItem.less';
import Card from '../Card/Card';
import classNames from 'classnames';
import Icon from '../Icon/Icon';
import MeterReadingPlausibilityIndicator from '../MeterReadingPlausibilityIndicator/MeterReadingPlausibilityIndicator';
import { EnvagoAria } from '../../../aria.types';

export interface JobListItemProps {
    firstLine?: string;
    title: string;
    titleSize?: 'default' | 'small';
    secondLine?: string;
    onClick: () => void;
    icon: ReactNode;
    color: 'gray-100' | string;
    isActive?: boolean;
    isGhost?: boolean;
    iconRight?: JobListItemIconType;
    plausibilityReading?: { readingValue?: number; minimumValue?: number; maximumValue?: number };
    aria?: EnvagoAria
}

export type JobListItemIconType = false | 'ARROW' | 'PENDING' | 'CHECK';

const JobListItem = ({
    firstLine,
    title,
    titleSize = 'default',
    secondLine,
    onClick,
    icon,
    color = 'gray-100',
    isActive = false,
    isGhost,
    iconRight = false,
    plausibilityReading,
    aria
}: JobListItemProps) => {
    return (
        <Card
            onClick={onClick}
            onKeyDown={(event) => {
                if (
                    event.key !== "Enter" &&
                    event.key !== " "
                ) {
                    return;
                }
                console.log("event", event)
                onClick();
            }}
            className={classNames(`job-list-item bg-gray-50 flex items-center cursor-pointer border-${color} border-l-4 hover:bg-white transition`, {
                'card--active': isActive,
                'hover:shadow': !isActive,
                'text-gray-500': isGhost,
                'text-gray-700': !isGhost,
            })}
            aria={aria}
        >
            <div  className={'ml-1 mr-3'}>{icon}</div>
            <div className={'flex-1'}>
                <p className={'text-xs leading-4 text-gray-500'}>{firstLine}</p>
                <p
                    className={classNames('font-medium', {
                        'text-xl': titleSize === 'default',
                        'text-l': titleSize === 'small',
                    })}
                    role={'heading'}
                    aria-level={3}
                    aria-roledescription={'Zähler- oder Auftragsnummer'}
                >
                    {title}
                </p>
                <p className={'text-xs leading-4 text-gray-500'}>{secondLine}</p>
            </div>
            <div className={'justify-self-end mr-2 flex items-center gap-1'}>
                {plausibilityReading && (
                    <>
                        <Icon className={'text-amber-600 h-5'} path={Icon.Path.mdiAlertOutline} aria={{ 'aria-hidden': 'true' }} />
                        <MeterReadingPlausibilityIndicator
                            readingValue={plausibilityReading.readingValue}
                            minimumValue={plausibilityReading.minimumValue}
                            maximumValue={plausibilityReading.maximumValue}
                        />
                    </>
                )}
                {iconRight === 'PENDING' && <Icon className={'text-yellow-500 h-4'} path={Icon.Path.mdiProgressClock} aria={{ 'aria-hidden': 'true' }} />}
                {iconRight === 'ARROW' && <Icon className={'text-gray-300 h-4'} path={Icon.Path.mdiChevronRight} aria={{ 'aria-hidden': 'true' }} />}
                {iconRight === 'CHECK' && <Icon className={'text-green-500 h-4'} path={Icon.Path.mdiCheck} aria={{ 'aria-hidden': 'true' }} />}
            </div>
        </Card>
    );
};

export default React.memo(JobListItem);
